import casedeal from "./casedeal.js";
import casedealinfo from "./casedealinfo.js";
import caseeatable from "./caseeatable.js";
import caseecharts from "./caseecharts.js";
import datacasemain from "./datacasemain.js";
import assetscard from "./assetscard.js";
import balancedata from "./balancedata.js";
import propertycard from "./propertycard.js";
import tableechart from "./tableechart.js";
import maintable from "./maintable.js";

export default {
  casedeal,
  casedealinfo,
  caseeatable,
  caseecharts,
  datacasemain,
  assetscard,
  balancedata,
  propertycard,
  tableechart,
  maintable,
};
